// Semicircle gauge geometry shared by the panel (React SVG) and the PDF (SVG string): 0% at the left end,
// 100% at the right end, continuous (never snapped to 0/25/50/75/100).
// Validated with the dataviz palette checks (lightness, chroma, CVD ΔE 19.7, contrast ≥ 3:1); prognosis is also dashed.
export const GAUGE_COLORS = { diagnosis: "#1F5FA8", prognosis: "#1E9C8E" } as const;
export const GAUGE_TRACK = "#D6DFE9";

export function gaugePoint(percent: number, cx: number, cy: number, r: number) {
  const t = Math.PI * (1 - Math.min(100, Math.max(0, percent)) / 100);
  return { x: cx + r * Math.cos(t), y: cy - r * Math.sin(t) };
}

/** SVG markup of a two-needle gauge; a missing value draws no needle. */
export function gaugeSvg(diagnosis: number | null, prognosis: number | null, opts: { width?: number; label?: string } = {}) {
  const w = opts.width ?? 160;
  const h = w * 0.58;
  const cx = w / 2;
  const cy = h - 6;
  const r = w / 2 - 10;
  const a = gaugePoint(0, cx, cy, r);
  const b = gaugePoint(100, cx, cy, r);
  const needle = (v: number | null, color: string, dash: string) => {
    if (v === null) return "";
    const p = gaugePoint(v, cx, cy, r - 6);
    return `<line x1="${cx}" y1="${cy}" x2="${p.x.toFixed(2)}" y2="${p.y.toFixed(2)}" stroke="${color}" stroke-width="3" stroke-linecap="round"${dash ? ` stroke-dasharray="${dash}"` : ""}/>`;
  };
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" role="img"${opts.label ? ` aria-label="${opts.label.replace(/"/g, "&quot;")}"` : ""}>
    <path d="M ${a.x} ${a.y} A ${r} ${r} 0 0 1 ${b.x} ${b.y}" fill="none" stroke="${GAUGE_TRACK}" stroke-width="10" stroke-linecap="round"/>
    ${needle(diagnosis, GAUGE_COLORS.diagnosis, "")}${needle(prognosis, GAUGE_COLORS.prognosis, "5 3")}
    <circle cx="${cx}" cy="${cy}" r="4.5" fill="#13253D"/>
  </svg>`;
}
